import { includes } from 'lodash';
import Footer from '../../components/Footer';
import InwardItemList from './InwardItemList';
import OutWardItem from './OutwardItem';
import PWAPickupForm from './PWAPickupForm';
import { UserHeader } from '../../components/AdminHeader';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const UserEntry = () => {
  const contentRef = useRef(null);
  const [value, setValue] = useState(1);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabValue = queryParams.get('tab');

  const permissions =
    localStorage?.getItem('permissions') &&
    JSON?.parse(localStorage?.getItem('permissions'));

  useEffect(() => {
    if (tabValue === 'delivered') {
      setValue(1);
    } else if (tabValue === 'pickup') {
      setValue(2);
    } else {
      setValue(0);
    }
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo(0, 0);
    }
  }, [value]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <UserHeader />
      <div
        ref={contentRef}
        style={{ flex: 1, overflowY: 'auto', paddingBottom: '64px' }}
      >
        {/* {value === 0 && includes(permissions, 'ALLOTED ITEM') && (
          <InwardItemList />
        )} */}
        {value === 1 && includes(permissions, 'DELIVERED ITEM') && (
          <OutWardItem />
        )}
        {value === 2 && includes(permissions, 'PICKED-UP ITEM') && (
          <PWAPickupForm />
        )}
      </div>
      <Footer setValue={setValue} value={value} />
    </div>
  );
};
export default UserEntry;
